import React, { Component } from 'react';
import {
  trackViewUpgradeBenefits,
  trackViewAdsExplained,
  trackViewFaqs,
  trackViewCompareProducts,
} from '../tracking/event';
import '../../../../sass/apps/commerce/mobile/upgrade_information.scss';
import UpgradingBenefits from '../desktop_personal_upgrade/upgrade_information_content/upgrading_benefits';
import AdsExplained from '../desktop_personal_upgrade/upgrade_information_content/ads_explained';
import CompareProducts from '../desktop_personal_upgrade/upgrade_information_content/compare_products';
import FAQ from '../desktop_personal_upgrade/upgrade_information_content/faq';

let trackingOnceUpgradeBenefit = false;
let trackingOnceAdsExplained = false;
let trackingOnceFaqs = false;
let trackingOnceCompareProducts = false;

class UpgradeInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      upgradingBenefits: false,
      adsExplained: false,
      compareProducts: false,
      faq: false,
    };
  }

  toggleDisplay(event) {
    const target = event.target.id;
    const x = document.querySelector('#commerce_app').offsetTop + 70;

    window.scrollTo({ top: x, behavior: 'smooth' });

    const newState = this.state;
    Object.keys(newState).forEach((key) => {
      newState[key] = key == target ? !this.state[target] : false;
    });
    this.setState(newState);
  }

  upgradingBenefits() {
    return this.state.upgradingBenefits ? (
      <UpgradingBenefits localisations={this.props.localisations} />
    ) : null;
  }

  adsExplained() {
    return this.state.adsExplained ? (
      <AdsExplained localisations={this.props.localisations} />
    ) : null;
  }

  faq() {
    return this.state.faq ? <FAQ /> : null;
  }

  compareProducts() {
    return this.state.compareProducts ? (
      <CompareProducts
        products={this.props.products}
        currencySymbol={this.props.currencySymbol}
        experiments={this.props.experiments}
      />
    ) : null;
  }

  render() {
    return (
      <ul
        id="top"
        className={`commerce__upgrade-info${
          this.props.winterSale ? ' commerce__upgrade-info--no-border' : ''
        }`}
      >
        <li className="commerce__upgrade-info-item">
          <button
            className={`button--link commerce__upgrade-info-toggle${
              this.state.upgradingBenefits ? '--selected' : ''
            }`}
            id="upgradingBenefits"
            onClick={(event) => {
              if (trackingOnceUpgradeBenefit == false) {
                trackViewUpgradeBenefits();
                trackingOnceUpgradeBenefit = true;
              }
              this.toggleDisplay(event);
            }}
          >
            Benefits of Upgrading
          </button>
          {this.upgradingBenefits()}
        </li>
        <li className="commerce__upgrade-info-item">
          <button
            className={`button--link commerce__upgrade-info-toggle${
              this.state.adsExplained ? '--selected' : ''
            }`}
            id="adsExplained"
            onClick={(event) => {
              if (trackingOnceAdsExplained == false) {
                trackViewAdsExplained();
                trackingOnceAdsExplained = true;
              }
              this.toggleDisplay(event);
            }}
          >
            Early Bird Access and Bold Ads Explained
          </button>
          {this.adsExplained()}
        </li>
        <li className="commerce__upgrade-info-item">
          <button
            className={`button--link commerce__upgrade-info-toggle${
              this.state.compareProducts ? '--selected' : ''
            }`}
            id="compareProducts"
            onClick={(event) => {
              if (trackingOnceCompareProducts == false) {
                trackViewCompareProducts();
                trackingOnceCompareProducts = true;
              }
              this.toggleDisplay(event);
            }}
          >
            Compare Products
          </button>
          {this.compareProducts()}
        </li>
        <li className="commerce__upgrade-info-item">
          <button
            className={`button--link commerce__upgrade-info-toggle${
              this.state.faq ? '--selected' : ''
            }`}
            id="faq"
            onClick={(event) => {
              if (trackingOnceFaqs == false) {
                trackViewFaqs();
                trackingOnceFaqs = true;
              }
              this.toggleDisplay(event);
            }}
          >
            Frequently Asked Questions
          </button>
          {this.faq()}
        </li>
      </ul>
    );
  }
}

export default UpgradeInformation;
